<template xmlns="http://www.w3.org/1999/html">
    <div>
        <div class="card card-with-shadow p-5 border-0">
            <div class="row">
                <div class="col-md-6">
                    <div>
                        <span class="text-muted font-size-90">
                            ID:
                        </span>
                        <span class="font-size-90">{{ transaction.id }}</span>
                    </div>
                </div>
                <div class="col-md-3">
                </div>
                <div class="col-md-3 text-right">
                </div>
            </div>
        </div>

        <app-confirmation-modal
            v-if="confirmationModalActive"
            :loading="loading"
            :message="promptMessage"
            :title="promptTitle"
            :firstButtonName="$t('yes')"
            :modal-class="promptClass"
            :icon="promptIcon"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed"
            @cancelled="cancelled"
            :self-close="false"
        />
    </div>
</template>

<script>
import {calenderTime} from "../../../../../common/Helper/Support/DateTimeHelper";
import {axiosDelete, axiosGet, urlGenerator} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "TransactionItemsRow",
    props: {
        transaction: {},
    },
    data() {
        return {
            urlGenerator,
            confirmationModalActive: false,
            loading: false,
            promptMessage: '',
            promptClass: '',
            promptTitle: '',
            promptIcon: '',
            actionType: '',
            inProgress: false,
        }
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        // confirmed() {
        //     if (this.actionType === 'delete') {
        //         this.deletePayrun();
        //     } else if (this.actionType === 'sendPayslip') {
        //         this.sendPayslips();
        //     }
        // },
        // cancelled() {
        //     this.confirmationModalActive = false;
        //     this.deleteUrl = ''
        //     this.payslipUrl = ''
        //     this.actionType = ''
        // },
        // updatePayrun(id) {
        //     this.$emit('openManualPayrun', id)
        // },
        closeConfirmation() {
            $("#app-confirmation-modal").modal('hide');
            $(".modal-backdrop").remove();
            this.loading = false;
            this.confirmationModalActive = false;
        }
    }
}
</script>

<style scoped>

</style>